export default __webpack_public_path__ + "static/media/card-theme7.4ddf5d71.svg";